<template>
  <div class="main" v-if="otherData">
    <div
      class="main__others"
      v-if="otherData.length>0"
    >
      <ul>
        <li
          :title="item.title+':'+item.value"
          v-for="(item, index) in otherData"
          :key="index"
        >
          <span class="title">{{item.title}}: </span>
          <span class="value">{{item.value}}</span>
        </li>
      </ul>
    </div>
    <div
      class="main__others"
      v-if="batteryList.length>0"
    >
      <ul>
        <li
          :title="'电芯'+`${index+1}`+'电压:'+item+'V'"
          v-for="(item, index) in batteryList"
          :key="index"
        >
          <span class="title">电芯{{index+1}}电压: </span>
          <span class="value">{{item}}V</span>
        </li>
      </ul>
    </div>
    <div
      class="main__others"
      v-if="tempList.length>0"
    >
      <ul>
        <li
          :title="'电芯'+`${index+1}`+'温度:'+item+'℃'"
          v-for="(item, index) in tempList"
          :key="index"
        >
          <span class="title">电芯{{index+1}}温度: </span>
          <span class="value">{{item}}℃</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      otherData: [
        { title: "电芯数量", value: "--" },
        { title: "充放电循环次数", value: "--" },
        { title: "设计容量", value: "--" },
        { title: "环境温度", value: "--" },
        { title: "mos温度", value: "--" },
        { title: "充满电容量", value: "--" },
        { title: "剩余容量", value: "--" },
        { title: "电流", value: "--" },
        { title: "电池组id	", value: "--" },
        { title: "总电压", value: "--" },
        { title: "电芯温度", value: "--" }
      ],
      batteryList: [],
      tempList: []
    };
  },
  props: {
    data: {
      type: Object
    }
  },
  watch: {
    data: {
      handler(val) {
        if (!val) return;
        const {
          batteryCount,
          chargeTime,
          designCharge,
          environmentTemp,
          mosTemp,
          pileCharge,
          pileCopacity,
          pileElectric,
          pileId,
          pileVoltage,
          batteryList,
          tempList
        } = val;
        this.otherData = [
          { title: "电芯数量", value: this.dataUnit(batteryCount, "串") },
          { title: "充放电循环次数", value: this.dataUnit(chargeTime, "次") },
          { title: "设计容量", value: this.dataUnit(designCharge, "ah") },
          { title: "环境温度", value: this.dataUnit(environmentTemp, "℃") },
          { title: "mos温度", value: this.dataUnit(mosTemp, "℃") },
          { title: "充满电容量", value: this.dataUnit(pileCharge, "ah") },
          { title: "剩余容量", value: this.dataUnit(pileCopacity, "ah") },
          { title: "电流", value: this.dataUnit(pileElectric, "A") },
          { title: "电池组id	", value: this.dataUnit(pileId) },
          { title: "总电压", value: this.dataUnit(pileVoltage, "V") }
        ];
        this.batteryList = batteryList || [];
        this.tempList = tempList || [];
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    dataUnit(data, unit) {
      if (data != undefined && data != null && unit) {
        data = data + unit;
        return data;
      }else if (data === "" || data === undefined || data === null) {
        return "--";
      }
      return data;
    }
  }
};
</script>
<style lang="scss" scoped>
.main {
  &__others {
    padding: 10px 0;
    display: flex;
    flex: 1;
    border-bottom: 1px solid rgb(216, 217, 218);
    ul {
      display: flex;
      flex: 1;
      flex-direction: row;
      flex-wrap: wrap;
      li {
        width: 20%;
        padding: 10px 0;
        word-break: keep-all;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        .title {
          font-size: 14px;
          color: #999999;
        }
        .value {
          font-size: 14px;
          color: #333;
        }
      }
    }
  }
}
</style>
